// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fonts_bulkreprocess {
  font-size: 12px;
}

.ng-autocompleteroutr {
  width: 370px;
}

.search_btn {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.reset_btn {
  background-color: #17a2b8;
  color: white;
  border: none;
}

::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -4% !important;
  margin-left: 3% !important;
}

.iconCheck {
  font-size: 12px;
  position: relative;
  top: -20%;
  margin-left: -3px;
}

.doller {
  position: absolute;
  top: -11px;
  left: 15%;
}

.textCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-success {
  color: #5dd077 !important;
}

.text-danger {
  color: #da606c !important;
}

.gui_ellipsis {
  font-weight: 600;
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pipeline_ellipsis {
  max-width: 89%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  top: 8%;
  left: 1%;
  padding-right: 1%;
}

.trans_ellipsis {
  max-width: 74%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 11%;
  padding-right: 1%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.iconPointer:hover {
  pointer-events: all;
}

.arrow_source {
  left: 5%;
  width: 97%;
  height: 2px;
  background-color: grey;
  position: relative;
  top: 36%;
}

.arr_chev {
  position: relative;
  text-align: right !important;
  right: -98%;
  color: grey;
  top: -9px;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 18px;
  position: absolute;
  top: 25%;
}

.pipeline_label {
  float: left;
  padding-right: 5%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 75%;
}

.source_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 76%;
}

.target_label {
  float: left;
  padding-right: 13%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 75%;
}

.processor_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.processor_feild {
  width: 88%;
}

.message_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.message_feild {
  float: left;
  width: 75%;
}

.transaction_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.transaction_feild {
  float: left;
  width: 100%;
}

.message_type_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_feild {
  width: 75%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.message_type_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.message_type {
  width: 100%;
  height: 35px;
  position: relative;
}

.messagefield_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.messagefield_feild {
  float: left;
  width: 75%;
}

.btnsdiv {
  padding-left: 16%;
}

.startdate_label {
  float: left;
  position: relative;
}

.startdate_feild {
  float: left;
  width: 75%;
  padding-left: 5%;
}

.enddate_label {
  float: left;
  position: relative;
}

.enddate_feild {
  float: left;
  width: 100%;
}

.listlabelaligh {
  padding-inline: 2%;
  padding-top: 1%;
}

.badmsgcheckbox_label {
  float: left;
  position: relative;
}

.badmsgcheckbox_feild {
  float: right;
  padding-top: 1%;
  padding-right: 50%;
}

.messagetype_feild {
  width: 100%;
  height: 30px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
  line-height: 10px;
}

.messagetype_feild_reason {
  width: 100%;
  height: 30px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
  line-height: 20px;
}

.rightfixed {
  position: fixed;
  right: 0;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 8px;
  }
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    width: 88%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 8px;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .transaction_feild {
    float: left;
    width: 64%;
  }
  .message_type {
    width: 53%;
    height: 35px;
    position: relative;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 85%;
  }
  .trans_ellipsis {
    max-width: 65%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .pipeline_feild {
    float: left;
    width: 97%;
  }
  .source_label {
    float: left;
    padding-right: 6%;
    position: relative;
    top: 0px;
  }
  .source_feild {
    float: left;
    width: 97%;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 0px;
  }
  .target_feild {
    float: left;
    width: 97%;
  }
  .processor_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    width: 88%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
  }
  .message_feild {
    float: left;
    width: 97%;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .transaction_feild {
    float: left;
    width: 97%;
  }
  .message_type {
    width: 86%;
    height: 35px;
    position: relative;
  }
  .reset_btn {
    padding-inline: 13% !important;
  }
  .gui_ellipsis {
    font-weight: 600;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 81%;
  }
  .trans_ellipsis {
    max-width: 52%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
.rightalign {
  float: right;
  padding-right: 60px;
  padding-top: 10px;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.routeName_class {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 77% !important;
  display: inline-block;
}

.notes_class {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  padding-block: 2px;
  width: 31%;
  float: right;
  position: relative;
  left: 4%;
}

::ng-deep .mat-badge-medium .mat-badge-content {
  width: 16px !important;
  height: 16px !important;
  line-height: 18px !important;
}

.btn_line_height {
  line-height: 30px !important;
}

.paddingleft {
  padding-left: 20px !important;
}

.form-control {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px !important;
}

.matchipinputfield input.mat-chip-input {
  width: 150px;
  margin: 4px;
  flex: 1 0 150px;
}

::ng-deep.examplechiplist2 .mat-form-field-infix .mat-chip-list-wrapper {
  padding-top: 0px !important;
  float: left;
}

::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -1% !important;
  margin-left: 2% !important;
  padding-bottom: 0px !important;
}

.customchip {
  font-size: 12px;
  min-height: 21px !important;
  padding-inline: 8px !important;
  float: left !important;
}

.fieldstyle {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
  border: transparent;
  width: 98% !important;
  min-height: 44px !important;
  max-height: 44px !important;
  overflow-x: hidden;
  overflow-y: auto;
}

::ng-deep.msgrep.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 3%;
  bottom: 9%;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

::ng-deep.msgreplist.mat-mdc-checkbox {
  padding-left: 0 !important;
  padding-right: 0px !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/bulkmessagereprocess/bulkmessagereprocess.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;;AAGA;EACI,YAAA;AAAJ;;AAEE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AACJ;;AACE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAEJ;;AAGE;EACE,0BAAA;EACA,0BAAA;AAAJ;;AAGE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AAAJ;;AAEE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AACJ;;AACE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAEJ;;AAAE;EACE,yBAAA;AAGJ;;AADE;EACE,yBAAA;AAIJ;;AADE;EACE,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIJ;;AADE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAIJ;;AADE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AAIJ;;AAFE;EACE,8BAAA;AAKJ;;AAHE;EACE,8BAAA;AAMJ;;AAJE;EACE,mBAAA;AAOJ;;AALE;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AAQJ;;AANE;EACE,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AASJ;;AAPE;EACE,8BAAA;AAUJ;;AAPE;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AAUJ;;AAPE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAUJ;;AARE;EACE,WAAA;EACA,UAAA;AAWJ;;AARE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAWJ;;AATE;EACE,WAAA;EACA,UAAA;AAYJ;;AATE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAYJ;;AAVE;EACE,WAAA;EACA,UAAA;AAaJ;;AAVE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAaJ;;AAXE;EAEE,UAAA;AAaJ;;AAXE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAcJ;;AAZE;EACE,WAAA;EACA,UAAA;AAeJ;;AAZE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAeJ;;AAbE;EACE,WAAA;EACA,WAAA;AAgBJ;;AAbE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAgBJ;;AAbE;EACE,UAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAgBJ;;AAdE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAiBJ;;AAfE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAkBJ;;AAfE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAkBJ;;AAhBE;EACE,WAAA;EACA,UAAA;AAmBJ;;AAhBE;EACE,iBAAA;AAmBJ;;AAhBE;EACE,WAAA;EACA,kBAAA;AAmBJ;;AAjBE;EACE,WAAA;EACA,UAAA;EACA,gBAAA;AAoBJ;;AAjBE;EACE,WAAA;EACA,kBAAA;AAoBJ;;AAlBE;EACE,WAAA;EACA,WAAA;AAqBJ;;AAlBE;EACE,kBAAA;EACA,eAAA;AAqBJ;;AAnBE;EACE,WAAA;EACA,kBAAA;AAsBJ;;AAnBE;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAsBJ;;AApBE;EACE,WAAA;EACA,YAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAuBJ;;AArBE;EACE,WAAA;EACA,YAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAwBJ;;AAtBE;EACE,eAAA;EACA,QAAA;AAyBJ;;AAtBE;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAyBJ;EAtBE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAwBJ;EAtBE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAwBJ;EAtBE;IAEE,UAAA;EAuBJ;EApBE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAsBJ;EAnBE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAqBJ;EAnBE;IACE,WAAA;IACA,UAAA;EAqBJ;EAnBE;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAqBJ;EAnBE;IACE,0BAAA;EAqBJ;EAnBE;IACE,cAAA;EAqBJ;EAnBE;IACE,cAAA;EAqBJ;EAlBI;IACE,qBAAA;EAoBN;AACF;AAhBE;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAkBJ;EAfE;IACE,WAAA;IACA,UAAA;EAiBJ;EAfE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAiBJ;EAfE;IACE,WAAA;IACA,UAAA;EAiBJ;EAfE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAiBJ;EAfE;IACE,WAAA;IACA,UAAA;EAiBJ;EAfE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAiBJ;EAfE;IAEE,UAAA;EAgBJ;EAbE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAeJ;EAbE;IACE,WAAA;IACA,UAAA;EAeJ;EAbE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAeJ;EAbE;IACE,WAAA;IACA,UAAA;EAeJ;EAbE;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAeJ;EAZE;IACE,8BAAA;EAcJ;EAXE;IACE,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAaJ;EAXE;IACE,0BAAA;EAaJ;EAXE;IACE,cAAA;EAaJ;EAXE;IACE,cAAA;EAaJ;EAVI;IACE,qBAAA;EAYN;AACF;AARE;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;AAUJ;;AAPE;EACE,sBAAA;AAUJ;;AAPE;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAUJ;;AANA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AASF;;AALA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAQF;;AALA;EACE,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AAQF;;AAJA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;AAOF;;AAFA;EACI,4BAAA;AAKJ;;AAFA;EAEE,6BAAA;AAIF;;AADC;EAEG,oDAAA;EACA,6BAAA;AAGJ;;AADA;EACE,YAAA;EACA,WAAA;EACF,eAAA;AAIA;;AAFA;EACE,2BAAA;EACA,WAAA;AAKF;;AAHA;EACE,0BAAA;EACA,0BAAA;EACC,8BAAA;AAMH;;AAHA;EAEI,eAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;AAKJ;;AAFE;EACE,yCAAA;EAAwC,6BAAA;EAAkC,mBAAA;EAC1E,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AAOJ;;AAHA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAMF;AALE;EACE,WAAA;EACA,YAAA;AAOJ;AANI;EACE,gCC1iBM;ED2iBN,oCC3iBM;ADmjBZ;AANI;EACE,YAAA;AAQN;AALE;EACE,YAAA;EACA,WAAA;AAOJ;;AAJA;EACE,0BAAA;EACA,6BAAA;AAOF;AANE;EACI,WAAA;EACA,YAAA;AAQN;AAPM;EACE,gCC7jBI;ED8jBJ,oCC9jBI;ADukBZ;AAPM;EACE,YAAA;AASR;AANE;EACE,uBAAA;EACA,sBAAA;AAQJ","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.fonts_bulkreprocess{\r\n  font-size:12px;\r\n}\r\n.ng-autocompleteroutr {\r\n    width: 370px;\r\n  }\r\n  .search_btn {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    border: none;\r\n    outline: none;\r\n  }\r\n  .reset_btn {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    border: none;\r\n    // padding-right: 5%;\r\n    // padding-left: 5%;\r\n  }\r\n\r\n  ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n    margin-top: -4% !important;\r\n    margin-left: 3% !important;\r\n    // padding-bottom: 10% !important;\r\n  }\r\n  .iconCheck {\r\n    font-size: 12px;\r\n    position: relative;\r\n    top: -20%;\r\n    margin-left: -3px;\r\n  }\r\n  .doller {\r\n    position: absolute;\r\n    top: -11px;\r\n    left: 15%;\r\n  }\r\n  .textCenter {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n  .text-success {\r\n    color: #5dd077 !important;\r\n  }\r\n  .text-danger {\r\n    color: #da606c !important;\r\n  }\r\n\r\n  .gui_ellipsis {\r\n    font-weight: 600;\r\n    width: 70%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  .pipeline_ellipsis {\r\n    max-width: 89%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    position: relative;\r\n    top: 8%;\r\n    left: 1%;\r\n    padding-right: 1%;\r\n  }\r\n\r\n  .trans_ellipsis {\r\n    max-width: 74%;\r\n    white-space: nowrap;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    position: relative;\r\n    top: 11%;\r\n    padding-right: 1%;\r\n  }\r\n  .active_card {\r\n    border-left: 4px solid #07a36e;\r\n  }\r\n  .progress_card {\r\n    border-left: 4px solid #ffc107;\r\n  }\r\n  .iconPointer:hover {\r\n    pointer-events: all;\r\n  }\r\n  .arrow_source {\r\n    left: 5%;\r\n    width: 97%;\r\n    height: 2px;\r\n    background-color: grey;\r\n    position: relative;\r\n    top: 36%;\r\n  }\r\n  .arr_chev {\r\n    position: relative;\r\n    text-align: right !important;\r\n    right: -98%;\r\n    color: grey;\r\n    top: -9px;\r\n  }\r\n  .failed_card {\r\n    border-left: 4px solid #da606c;\r\n  }\r\n\r\n  .copy_icon {\r\n    margin-left: 2%;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    position: absolute;\r\n    top: 25%;\r\n  }\r\n\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 5%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .pipeline_feild {\r\n    float: left;\r\n    width: 75%;\r\n  }\r\n\r\n  .source_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .source_feild {\r\n    float: left;\r\n    width: 76%;\r\n  }\r\n\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 13%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .target_feild {\r\n    float: left;\r\n    width: 75%;\r\n  }\r\n\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 7%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .processor_feild {\r\n\r\n    width: 88%;\r\n  }\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .message_feild {\r\n    float: left;\r\n    width: 75%;\r\n  }\r\n\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 3%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .transaction_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_type_label {\r\n    float: left;\r\n    padding-right: 3%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .message_type_feild {\r\n    width: 75%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    top: -6px;\r\n  }\r\n  .message_type_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .message_type {\r\n    width: 100%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n\r\n  .messagefield_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .messagefield_feild {\r\n    float: left;\r\n    width: 75%;\r\n  }\r\n\r\n  .btnsdiv {\r\n    padding-left: 16%;\r\n  }\r\n\r\n  .startdate_label {\r\n    float: left;\r\n    position: relative;\r\n  }\r\n  .startdate_feild {\r\n    float: left;\r\n    width: 75%;\r\n    padding-left: 5%;\r\n  }\r\n\r\n  .enddate_label {\r\n    float: left;\r\n    position: relative;\r\n  }\r\n  .enddate_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .listlabelaligh {\r\n    padding-inline: 2%;\r\n    padding-top: 1%;\r\n  }\r\n  .badmsgcheckbox_label {\r\n    float: left;\r\n    position: relative;\r\n  }\r\n\r\n  .badmsgcheckbox_feild {\r\n    float: right;\r\n    padding-top: 1%;\r\n    padding-right: 50%;\r\n  }\r\n  .messagetype_feild {\r\n    width: 100%;\r\n    height: 30px;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    padding-bottom: 1%;\r\n    line-height: 10px;\r\n  }\r\n  .messagetype_feild_reason {\r\n    width: 100%;\r\n    height: 30px;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    padding-bottom: 1%;\r\n    line-height: 20px;\r\n  }\r\n  .rightfixed {\r\n    position: fixed;\r\n    right: 0;\r\n  }\r\n\r\n  @media screen and (min-width: 900px) and (max-width: 1024px) {\r\n    .pipeline_label {\r\n      float: left;\r\n      padding-right: 2%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n\r\n    .target_label {\r\n      float: left;\r\n      padding-right: 9%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .processor_label {\r\n      float: left;\r\n      padding-right: 2%;\r\n      position: relative;\r\n      top: 8px;\r\n      font-size: 12px;\r\n      font-weight: 700;\r\n    }\r\n    .processor_feild {\r\n\r\n      width: 88%;\r\n    }\r\n\r\n    .message_label {\r\n      float: left;\r\n      padding-right: 1%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n\r\n    .transaction_label {\r\n      float: left;\r\n      padding-right: 2%;\r\n      position: relative;\r\n      top: 8px;\r\n    }\r\n    .transaction_feild {\r\n      float: left;\r\n      width: 64%;\r\n    }\r\n    .message_type {\r\n      width: 53%;\r\n      height: 35px;\r\n      position: relative;\r\n    }\r\n    .message_type_margin {\r\n      margin-left: 1% !important;\r\n    }\r\n    .pipeline_ellipsis {\r\n      max-width: 85%;\r\n    }\r\n    .trans_ellipsis {\r\n      max-width: 65%;\r\n    }\r\n    .message_btns {\r\n      span {\r\n        padding: 0 !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (min-width: 500px) and (max-width: 786px) {\r\n    .pipeline_label {\r\n      float: left;\r\n      padding-right: 2%;\r\n      position: relative;\r\n      top: 0px;\r\n    }\r\n\r\n    .pipeline_feild {\r\n      float: left;\r\n      width: 97%;\r\n    }\r\n    .source_label {\r\n      float: left;\r\n      padding-right: 6%;\r\n      position: relative;\r\n      top: 0px;\r\n    }\r\n    .source_feild {\r\n      float: left;\r\n      width: 97%;\r\n    }\r\n    .target_label {\r\n      float: left;\r\n      padding-right: 9%;\r\n      position: relative;\r\n      top: 0px;\r\n    }\r\n    .target_feild {\r\n      float: left;\r\n      width: 97%;\r\n    }\r\n    .processor_label {\r\n      float: left;\r\n      padding-right: 1%;\r\n      position: relative;\r\n      top: 0px;\r\n      font-size: 12px;\r\n      font-weight: 700;\r\n    }\r\n    .processor_feild {\r\n\r\n      width: 88%;\r\n    }\r\n\r\n    .message_label {\r\n      float: left;\r\n      padding-right: 1%;\r\n      position: relative;\r\n      top: 0px;\r\n    }\r\n    .message_feild {\r\n      float: left;\r\n      width: 97%;\r\n    }\r\n    .transaction_label {\r\n      float: left;\r\n      padding-right: 2%;\r\n      position: relative;\r\n      top: 0px;\r\n    }\r\n    .transaction_feild {\r\n      float: left;\r\n      width: 97%;\r\n    }\r\n    .message_type {\r\n      width: 86%;\r\n      height: 35px;\r\n      position: relative;\r\n    }\r\n\r\n    .reset_btn {\r\n      padding-inline: 13% !important;\r\n    }\r\n\r\n    .gui_ellipsis {\r\n      font-weight: 600;\r\n      width: 65%;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n    .message_type_margin {\r\n      margin-left: 1% !important;\r\n    }\r\n    .pipeline_ellipsis {\r\n      max-width: 81%;\r\n    }\r\n    .trans_ellipsis {\r\n      max-width: 52%;\r\n    }\r\n    .message_btns {\r\n      span {\r\n        padding: 0 !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  .rightalign {\r\n    float: right;\r\n    padding-right: 60px;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {\r\n    height: 0px !important;\r\n  }\r\n\r\n  ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n    top: 0;\r\n    height: 0px !important;\r\n    overflow: hidden;\r\n  }\r\n\r\n\r\n.date_control_style{\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n  // padding-block: 3%;\r\n}\r\n\r\n.routeName_class{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 77% !important;\r\n  display: inline-block;\r\n}\r\n\r\n.notes_class{\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-block: 2px;\r\n  width: 31%;\r\n  float: right;\r\n  position: relative;\r\n  left: 4%;\r\n}\r\n\r\n\r\n::ng-deep .mat-badge-medium .mat-badge-content {\r\n  width: 16px !important;\r\n  height: 16px !important;\r\n  line-height: 18px !important;\r\n}\r\n\r\n\r\n\r\n.btn_line_height{\r\n    line-height: 30px !important;\r\n}\r\n\r\n.paddingleft\r\n{\r\n  padding-left: 20px!important;\r\n}\r\n\r\n .form-control\r\n  {\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;\r\n    border-radius: 5px !important;\r\n  }\r\n.matchipinputfield input.mat-chip-input {\r\n  width: 150px;\r\n  margin: 4px;\r\nflex: 1 0 150px;\r\n }\r\n::ng-deep.examplechiplist2 .mat-form-field-infix .mat-chip-list-wrapper{\r\n  padding-top: 0px !important;\r\n  float: left;\r\n}\r\n::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  margin-top: -1% !important;\r\n  margin-left: 2% !important;\r\n   padding-bottom: 0px !important;\r\n}\r\n\r\n.customchip\r\n  {\r\n    font-size: 12px;\r\n    min-height: 21px !important;\r\n    padding-inline: 8px !important;\r\n    float: left !important;\r\n  }\r\n\r\n  .fieldstyle{\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%); border-radius: 5px !important;    border: transparent;\r\n    width:98% !important;\r\n    min-height: 44px !important;\r\n    max-height: 44px !important;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n  }\r\n\r\n\r\n::ng-deep.msgrep.mat-mdc-checkbox {\r\n  height: 16px;\r\n  width: 16px;\r\n  position: relative;\r\n  right: 3%;\r\n  bottom: 9%;\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n}\r\n::ng-deep.msgreplist.mat-mdc-checkbox {\r\n  padding-left: 0 !important;\r\n  padding-right: 0px !important;\r\n  .mdc-checkbox {\r\n      width: 16px;\r\n      height: 16px;\r\n      .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n        border-color: $btn-color;\r\n        background-color: $btn-color;\r\n      }\r\n      .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n        color: white;\r\n    }\r\n    }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
